<template>
  <div>
    <div
      :style="`z-index: ${(modalIndex + 1) * 10} * 10`"
      :class="`modal fade ${ !isOpen ? '' : 'show'}`">
      <div 
        :style="`z-index: ${(modalIndex + 1) * 10}`"
        :class="`modal-dialog modal-${modalSize == null ? '' : modalSize} modal-dialog-centered modal-dialog-scrollable`">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{modalTitle}}</h5>
            <button type="button" class="btn-close" aria-label="Close" v-on:click="close"></button>
          </div>
          <div class="modal-body">
           <slot/>
          </div>
          <div class="modal-footer">
            <Button :type="ButtonTypes.default" :onClick="handleClose" label="닫기"/>
            <Button
              v-show="confirmButtonTitle !== undefined"
              :type="ButtonTypes.blue" 
              :onClick="confirm" 
              :label="confirmButtonTitle"
              :loading="loading"
              :disabled="loading || !!confirmDisabled"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button.vue";
import {ButtonTypes} from "@/util/enums";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "AdminModal",
  computed: {
    ...mapGetters("modals", ["allModals"]),
    ButtonTypes() {
      return ButtonTypes
    },
    modalIndex() {
      if (!this.name) return 0
      if (this.name === "commonModal") return 1000;
      return this.allModals?.findIndex(modal => modal.name === this.name) || 0; 
    }
  },
  components: {Button},
  props: ['isOpen', 'modalTitle', 'close', 'confirm', 'confirmButtonTitle','modalSize', 'loading', 'name', 'confirmDisabled'],
  mounted() {
    console.log(this.name)
    this.openModal(this.name)
  },
  methods: {
    ...mapActions("modals", ["openModal", "closeModal"]),
    handleClose() {
      this.closeModal(this.name);
      this.close();
    }
  },
}
</script>

<style scoped>
.modal {
  transition: opacity 0.25s ease;
  background-color: rgba(0,0,0, 0.5);
}
.show{
  display: block !important;
}
</style>